"use client";
import {
  usePopoverDisclosureArrow
} from "./SFRUIDAI.js";
import {
  useSelectContext
} from "./6RJCEQC6.js";
import {
  createComponent,
  createElement,
  createHook
} from "./LFJDOMBA.js";
import {
  __objRest,
  __spreadValues
} from "./2SMRF6AD.js";

// src/select/select-arrow.ts
var useSelectArrow = createHook(
  (_a) => {
    var _b = _a, { store } = _b, props = __objRest(_b, ["store"]);
    const context = useSelectContext();
    store = store || context;
    props = usePopoverDisclosureArrow(__spreadValues({ store }, props));
    return props;
  }
);
var SelectArrow = createComponent((props) => {
  const htmlProps = useSelectArrow(props);
  return createElement("span", htmlProps);
});
if (process.env.NODE_ENV !== "production") {
  SelectArrow.displayName = "SelectArrow";
}

export {
  useSelectArrow,
  SelectArrow
};
